import React from 'react';
import { observer } from 'mobx-react';

import Styled from 'styled';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import asc from 'four-nets/icons/svg/icon_sorting-ascending.svg';
import desc from 'four-nets/icons/svg/icon_sorting-descending.svg';
import clock from 'four-nets/icons/svg/icon_time.svg';
import defaultStyles from './sort-date-view.scss';


@Styled(defaultStyles)
@observer
class SortDateView extends React.Component {
    onClick = event => {
        if (!this.props.sortable) {
            return;
        }
        if (this.props.onClick) {
            this.props.onClick(event, !this.props.ascending);
        }
    };

    render() {
        const { styles, sortable, ascending } = this.props;

        const classNames = [styles.sortDate];

        if (sortable) {
            classNames.push(styles.sortable);
        }

        if (ascending) {
            classNames.push(styles.ascending);
        } else {
            classNames.push(styles.descending);
        }

        return (
            <button disabled={!this.props.sortable} onClick={this.onClick} className={classNames.join(' ')}>
                <SVGIcon style={{image: styles.icon}} src={clock} />
                {sortable ? (
                    <span className={styles.sorting}>
                        {ascending ? <SVGIcon style={{image: styles.icon}} src={asc} /> : <SVGIcon style={{image: styles.icon}} src={desc} />}
                    </span>
                ) : null}
            </button>
        );
    }
}

export default SortDateView;
